import articles from './articles';
import assertions from './assertions';
import boards from './boards';
import course_boards from './course_boards';
import contents from './contents';
import exams from './exams';
import exam_applications from './exam_applications';
import exam_groups from './exam_groups';
import exam_modes from './exam_modes';
import examination_boards from './examination_boards';
import files from './files';
import institutions from './institutions';
import list_items from './list_items';
import lists from './lists';
import questions from './questions';
import question_applications from './question_applications';
import solutions from './solutions';
import state from './state';
import mutations from './mutations';
import assignments from './assignments';
import videos from './videos';

export default {
  state,
  mutations,
  actions: {
    ...articles.actions,
    ...assertions.actions,
    ...assignments.actions,
    ...boards.actions,
    ...course_boards.actions,
    ...contents.actions,
    ...exams.actions,
    ...exam_applications.actions,
    ...exam_modes.actions,
    ...exam_groups.actions,
    ...examination_boards.actions,
    ...files.actions,
    ...institutions.actions,
    ...list_items.actions,
    ...lists.actions,
    ...questions.actions,
    ...question_applications.actions,
    ...solutions.actions,
    ...videos.actions,
  },
  getters: {
    ...articles.getters,
    ...assertions.getters,
    ...assignments.getters,
    ...boards.getters,
    ...course_boards.getters,
    ...contents.getters,
    ...exams.getters,
    ...exam_applications.getters,
    ...exam_modes.getters,
    ...exam_groups.getters,
    ...examination_boards.getters,
    ...institutions.getters,
    ...list_items.getters,
    ...lists.getters,
    ...questions.getters,
    ...question_applications.getters,
    ...solutions.getters,
    ...videos.getters,
  },
};
